module.exports = __webpack_public_path__ + "images/Add.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/Add.png
// module id = 132
// module chunks = 0 1